import React from 'react'
import PropTypes from 'prop-types'
import ErrorComponent from 'components/Errors/ErrorComponent'

const PageAppError = ({ appError }) => {
    return <ErrorComponent error={appError} />
}

export default PageAppError

PageAppError.propTypes = {
    appError: PropTypes.object.isRequired,
}
